// Typed access to the app-local SecondaryDisplayDiagnostics Android plugin.
// Ported from cartadigital-pos app/utils/secondary-display-diagnostics.ts.
import { Capacitor, registerPlugin } from '@capacitor/core';

export interface ISecondaryDisplayDiagnosticsOptions {
  /**
   * If true, the native layer will attempt to show a test Presentation on each
   * non-default display and record success/failure.
   */
  runPresentationTests?: boolean;
}

export interface ISecondaryDisplayDiagnosticsResult {
  /** Opaque JSON-like payload (safe to stringify). */
  report: Record<string, unknown>;
}

export interface ISecondaryDisplayDiagnosticsPlugin {
  getDiagnostics: (
    options?: ISecondaryDisplayDiagnosticsOptions
  ) => Promise<ISecondaryDisplayDiagnosticsResult>;
}

export const SecondaryDisplayDiagnostics =
  registerPlugin<ISecondaryDisplayDiagnosticsPlugin>(
    'SecondaryDisplayDiagnostics'
  );

export function isSecondaryDisplayDiagnosticsAvailable(): boolean {
  const isNative = Capacitor.isNativePlatform?.() ?? false;
  return isNative && Capacitor.getPlatform() === 'android';
}
